(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bbf-lp-about"] && !Shopify.designMode) return;
  try {
    

  // Queue Lightbox
  $('.bbf-lp-gallery__lightbox').simpleLightbox();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-products-product-intro"] && !Shopify.designMode) return;
  try {
    
(function () {
function openPanel(trigger, panel) {
    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    panel.style.height = '0px';
    panel.style.transition = 'height 220ms ease';
    panel.offsetHeight;
    panel.style.height = panel.scrollHeight + 'px';
    panel.addEventListener('transitionend', function onEnd(e) {
    if (e.propertyName !== 'height') return;
    panel.style.height = 'auto';
    panel.style.transition = '';
    panel.removeEventListener('transitionend', onEnd);
    });
}

function closePanel(trigger, panel) {
    trigger.setAttribute('aria-expanded', 'false');
    panel.style.height = panel.scrollHeight + 'px';
    panel.style.transition = 'height 220ms ease';
    panel.offsetHeight;
    panel.style.height = '0px';
    panel.addEventListener('transitionend', function onEnd(e) {
    if (e.propertyName !== 'height') return;
    panel.hidden = true;
    panel.style.height = '';
    panel.style.transition = '';
    panel.removeEventListener('transitionend', onEnd);
    });
}

// Main accordions
document.querySelectorAll('[data-accordion]').forEach((accordion) => {
    const triggers = accordion.querySelectorAll('.m-accordion__trigger');
    triggers.forEach((trigger) => {
    const panelId = trigger.getAttribute('aria-controls');
    const panel = accordion.querySelector('#' + panelId);

    if (!trigger || !panel) return;

    trigger.addEventListener('click', () => {
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
    if (isOpen) closePanel(trigger, panel);
    else openPanel(trigger, panel);
    });
    });
});

// Inner accordions
document.querySelectorAll('.product-intro__drop-down-button').forEach((trigger) => {
    trigger.addEventListener('click', () => {
    const panelId = trigger.getAttribute('aria-controls');
    const panel = document.querySelector('#' + panelId);
    if (!panel) return;

    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
    if (isOpen) closePanel(trigger, panel);
    else openPanel(trigger, panel);
    });
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orchard-lp-about"] && !Shopify.designMode) return;
  try {
    

  // Queue Lightbox
  $('.orchard-lp-gallery__lightbox').simpleLightbox();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orchard-lp-slider--mobile"] && !Shopify.designMode) return;
  try {
    
  // Slick Slider
  $('#orchard-mobile_slider__slider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    customPaging: function(slider, index) {
      var pageNum = Math.ceil((index + 1) / 5);
      var maxPages = Math.ceil(slider.slideCount / 5);
      if (index % 5 === 0) {
        return '<button type="button" role="tab"><span>' + pageNum + ' / ' + maxPages + '</span></button>';
      }
      return '';
    },
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 690,
        settings: {
          dots: false,
          slidesToShow: 1
        }
      }
    ]
  });

  // Queue Lightbox
  $('.orchard-lp-slider--mobile__lightbox').simpleLightbox();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pbl-roster-rt"] && !Shopify.designMode) return;
  try {
    
  // Slick Slider
  $('#tnp-roster__slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    customPaging: function(slider, index) {
      var pageNum = Math.ceil((index + 1) / 5);
      var maxPages = Math.ceil(slider.slideCount / 5);
      if (index % 5 === 0) {
        return '<button type="button" role="tab"><span>' + pageNum + ' / ' + maxPages + '</span></button>';
      }
      return '';
    },
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 690,
        settings: {
          dots: false,
          slidesToShow: 1
        }
      }
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pbl-roster"] && !Shopify.designMode) return;
  try {
    
  // Slick Slider
  $('#tnp-roster__slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    customPaging: function(slider, index) {
      var pageNum = Math.ceil((index + 1) / 5);
      var maxPages = Math.ceil(slider.slideCount / 5);
      if (index % 5 === 0) {
        return '<button type="button" role="tab"><span>' + pageNum + ' / ' + maxPages + '</span></button>';
      }
      return '';
    },
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 690,
        settings: {
          dots: false,
          slidesToShow: 1
        }
      }
    ]
  });

  } catch(e) { console.error(e); }
})();
})();
